import React, { ReactNode } from 'react'

import styled from 'styled-components'

import { Icon, Txt } from 'src/components/atoms'
import { SearchedUserListItem } from 'src/components/molecules'

import { ProfileEntity, UserEntity } from 'src/types'

const List = styled.ul`
  border-radius: 0 0 8px 8px;
  overflow: auto;
  max-height: 21.43rem;
  // listの中にネストする際に意図しないmarginが入るのを防ぐ
  margin-left: 0;
`

const ListItem = ({ children }: { children: ReactNode }) => {
  return <li className="tw-border-b tw-border-border-secondary last:tw-border-0">{children}</li>
}

// UserEntityを継承した型をusersで受取、onSelectで同じ型を返す
type Props<T extends UserEntity> = {
  users: T[]
  profile?: ProfileEntity
  searchWords?: string[]
  onSelect: (user: T) => void
  onBatchSelect?: (users: T[]) => void
  isShowBatchSelect?: boolean
  className?: string
}

export const SearchedUserList = <T extends UserEntity>({
  users,
  profile,
  searchWords,
  onSelect,
  onBatchSelect,
  isShowBatchSelect,
  className,
}: Props<T>) => {
  return (
    <div className={className}>
      <List className="tw-border tw-border-border-secondary">
        {users.map(user => (
          <ListItem key={user.id}>
            <SearchedUserListItem
              user={user}
              profile={profile}
              searchWords={searchWords}
              onSelect={onSelect}
            />
          </ListItem>
        ))}
        {isShowBatchSelect && users.length > 0 && (
          <ListItem>
            <button
              type="button"
              onClick={() => onBatchSelect?.(users)}
              className="tw-w-full tw-p-[1.14rem] tw-bg-surface-primary hover:tw-bg-surface-secondary tw-text-right"
            >
              <div className="tw-text-standardText-primary tw-inline-flex tw-items-center tw-gap-s-4">
                <Icon path="plus/soft/line" className="tw-w-s0" />
                <Txt sizeType="s">まとめてアサイン</Txt>
              </div>
            </button>
          </ListItem>
        )}
      </List>
    </div>
  )
}
